// components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const token = sessionStorage.getItem('auth_token');

  if (!token) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;
